<template>
  <v-theme-provider>
    <base-section id="news" space="40" class="news-section">
      <v-container class="news-container">
        <v-row justify="center">
          <v-col cols="12">
            <div class="news-heading">
              <base-section-heading title="Berita" />
              <div class="news-subtitle">
                Informasi terbaru dan insight pilihan untuk Anda.
              </div>
            </div>
            <base-body space="0">
              <v-container fluid>
                <v-row dense class="news-grid">
                  <v-col xs="12" md="12" cols="12">
                    <div class="news-category-bar">
                      <div class="news-category-label">Kategori</div>
                      <v-btn-toggle
                        v-model="select"
                        class="news-category-toggle"
                        mandatory
                      >
                        <v-btn
                          v-for="item in category"
                          :key="item"
                          :value="item"
                          small
                          depressed
                          class="news-category-btn"
                        >
                          {{ item }}
                        </v-btn>
                      </v-btn-toggle>
                    </div>
                  </v-col>
                  <v-col v-for="data in filtered" :key="data.web_news_id" md="4" xs="12" cols="12">
                    <v-card class="news-card" elevation="0" @click="Detail(data.web_news_id)">
                      <v-img
                        :src="data.web_news_src_url"
                        class="news-image"
                        height="240px"
                        :alt="data.web_news_name"
                      >
                        <div class="news-image-overlay">
                          <span class="news-chip">{{ data.web_news_category }}</span>
                        </div>
                      </v-img>
                      <v-card-text class="news-body">
                        <div class="news-meta">
                          <span class="news-date">{{
                            FormatDateFullOnlyDate(data.web_news_cdate)
                          }}</span>
                          <span class="news-dot">•</span>
                          <span class="news-meta-cat">{{ data.web_news_category }}</span>
                        </div>
                        <div class="news-title">{{ data.web_news_name }}</div>
                        <div class="news-excerpt">
                          {{ MaxLength(data.web_news_desc || data.web_news_name, 110) }}
                        </div>
                      </v-card-text>
                      <v-card-actions class="news-actions">
                        <v-btn text small class="news-read">
                          Baca Selengkapnya
                          <v-icon small>mdi-arrow-right</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn icon class="news-share" @click.stop="Share(data.web_news_id)">
                          <v-icon>mdi-whatsapp</v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </base-body>
          </v-col>
        </v-row>
      </v-container>
    </base-section>
  </v-theme-provider>
</template>

<script>
export default {
  name: "SectionNews",
  data: () => ({
    select: "Semua",
    posts: [],
    category: ["Semua", "berita", "tips", "csr"]
  }),
  created() {
    this.List();
  },
  computed: {
    filtered() {
      const self = this;
      if (self.select === "Semua") {
        return self.posts;
      } else {
        return self.posts.filter(function(data) {
          return self.select === data.web_news_category;
        });
      }
    }
  },
  methods: {
    List() {
      this.loading = true;
      let formdata = {
        web_news_id: "",
        web_news_type: "news",
        web_news_actived: "true",
        order_by: "web_news_cdate",
        order_type: "DESC"
      };
      let param = this.$functions.ParamPOST(formdata);
      this.$axios
        .post(this.$functions.UrlPOST("apiWebNewsList"), param, {
          headers: {
            "Content-Type": "text/plain; charset=ISO-8859-1"
          }
        })
        .then(response => {
          this.posts = response.data;
          this.loading = false;
        })
        .catch(e => {
          alert(e);
          this.loading = false;
        });
    },
    MaxLength(content, max) {
      if (!content) {
        return "";
      }
      let safeContent = String(content);
      let returns = safeContent;
      if (safeContent.length >= max) {
        returns = safeContent.substr(0, max) + "... ";
      }
      return returns;
    },
    Share(id) {
      let paramurl = this.$functions.AppURL() + "/berita-detail/" + id;
      window.open("https://wa.me/?text=" + encodeURIComponent(paramurl));
    },
    Detail(url) {
      this.$router.push({ name: "berita-detail", params: { url: url } });
    },
    FormatDateFullOnlyDate(date) {
      return this.$functions.FormatDateFullOnlyDate(date);
    }
  }
};
</script>

<style scoped>
.news-section {
  position: relative;
  overflow: hidden;
}

.news-section::before {
  content: "";
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 15% 10%, rgba(0, 31, 72, 0.08), transparent 45%),
    radial-gradient(circle at 85% 15%, rgba(0, 31, 72, 0.05), transparent 40%),
    linear-gradient(180deg, rgba(248, 250, 252, 0.9) 0%, rgba(248, 250, 252, 0.4) 100%);
  pointer-events: none;
}

.news-container {
  position: relative;
  z-index: 1;
}

.news-heading {
  margin-bottom: 12px;
  text-align: center;
}

.news-subtitle {
  margin-top: 6px;
  color: #475569;
  font-size: 15px;
  line-height: 1.6;
}

.news-category-bar {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 22px;
}

.news-category-label {
  font-size: 12px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #6b7280;
  font-weight: 600;
  text-align: center;
}

::v-deep .news-category-toggle {
  display: inline-flex;
  align-items: center;
  padding: 6px;
  border-radius: 999px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
  overflow-x: auto;
  white-space: nowrap;
}

::v-deep .news-category-btn.v-btn {
  margin: 0 4px;
  border-radius: 999px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.08em;
  color: #0f172a;
  background: transparent;
  box-shadow: none;
  transition: background 150ms ease, color 150ms ease, box-shadow 150ms ease, transform 150ms ease;
}

::v-deep .news-category-btn.v-btn:hover {
  background: rgba(15, 23, 42, 0.06);
}

::v-deep .news-category-btn.v-btn.v-btn--active {
  background: #001f48;
  color: #ffffff;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.25);
  transform: translateY(-1px);
}

@media (max-width: 600px) {
  .news-category-bar {
    align-items: flex-start;
  }

  ::v-deep .news-category-toggle {
    width: 100%;
  }
}

.news-grid {
  row-gap: 20px;
}

.news-card {
  border-radius: 18px;
  border: 1px solid rgba(2, 6, 23, 0.08);
  background: #ffffff;
  overflow: hidden;
  transition: box-shadow 200ms ease, transform 200ms ease, border-color 200ms ease;
  cursor: pointer;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.news-card:hover {
  border-color: rgba(0, 31, 72, 0.25);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.18);
  transform: translateY(-4px);
}

.news-image {
  position: relative;
  border-bottom: 1px solid rgba(15, 23, 42, 0.08);
  overflow: hidden;
}

.news-image::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 35%, rgba(0, 0, 0, 0.45) 100%);
}

::v-deep .news-image .v-image__image {
  transition: transform 250ms ease;
}

.news-card:hover ::v-deep .news-image .v-image__image {
  transform: scale(1.04);
}

.news-image-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  padding: 14px;
  z-index: 1;
  pointer-events: none;
}

.news-chip {
  background: rgba(255, 255, 255, 0.96);
  color: #001f48;
  font-weight: 600;
  font-size: 11px;
  padding: 6px 10px;
  border-radius: 10px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  border: 1px solid rgba(0, 31, 72, 0.12);
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.12);
  line-height: 1;
  pointer-events: none;
}

.news-body {
  padding: 16px 18px 12px;
  flex: 1 1 auto;
}

.news-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: 600;
}

.news-dot {
  color: #cbd5f5;
}

.news-title {
  margin-top: 10px;
  font-size: 18px;
  line-height: 1.4;
  font-weight: 700;
  color: #0f172a;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.news-excerpt {
  margin-top: 8px;
  color: #475569;
  font-size: 14px;
  line-height: 1.6;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.news-actions {
  padding: 8px 14px 14px;
}

::v-deep .news-read.v-btn {
  text-transform: none;
  font-weight: 600;
  color: #001f48;
  letter-spacing: 0.02em;
  padding-left: 6px;
}

::v-deep .news-share.v-btn {
  color: #0f172a;
}

::v-deep .news-read.v-btn .v-icon {
  margin-left: 6px;
}

@media (max-width: 960px) {
  .news-title {
    font-size: 17px;
  }
}

@media (max-width: 600px) {
  .news-card {
    border-radius: 16px;
  }

  .news-actions {
    padding-bottom: 12px;
  }

  .news-subtitle {
    font-size: 14px;
  }
}
</style>
